import Tesseract from "tesseract.js";

export const processImage = async (file: File): Promise<string> => {
  const worker = await Tesseract.createWorker("eng");
  
  try {
    const { data } = await worker.recognize(file);
    return data.text;
  } catch (error) {
    console.error("OCR error:", error);
    return "";
  } finally {
    await worker.terminate();
  }
};
